var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('plain-form',{attrs:{"submit-button-text":"Create","server-errors":_vm.serverErrors,"form":_vm.$options.formData,"disabled":_vm.isContentLoading},on:{"submit":_vm.submit,"model-change":_vm.customValidation}})}
var staticRenderFns = []

export { render, staticRenderFns }